export class SendSmsConstants {
    static COMPONENT_NAME = "send email component";
    static SMS_TEXT_CONTROL = "smsText";
    static SMS_TEMPLATE_LABEL = "SMS template";
    static SMS_TEXT_LABEL = "SMS text";
    static SEND_SMS_LABEL = "Send SMS";
    static VALIDATION_MESSAGES = {
        smsSender: "Please enter sender's cellphone number.",
        emailText: "Please enter the SMS text."
    };
    static NO_RECIPIENT_ERR_MSG = "Please select a recipient with a valid cellphone number or complete all required fields from the recipient form including cellphone number.";
    static SEND_EMAIL_ERR_OBJ = "sendSMS";
    static NO_TEMPLATE_ERR_MSG = "Please select a template to download";
    static NO_COMM_MECHANISM_ERR_MSG;
    static noCommunicationTypeErrMsg = "No communication type selected.";
    static noSMSTextErrMsg = "SMS text is required";
    static smsTextConst = "sms";
    static smsCommMechConst = "SMS";
    static smsCommDirectionConst = "Outgoing";
    static invalidTemplateTypes = "One or more templates are configured with invalid template types. Please contact your system administrator.";
    static adHocComms = "AdHocComms";
    static CONFIRM_SMS_LENGTH_TITLE = 'Confirm SMS';
    static CONFIRM_SMS_LENGTH_MESSAGE = 'To accommodate the content, we will need to send {messageCount} message(s). Do you want to continue?';
    static alertMessages = {
        communicationLogged: "Communication logged",
        sendSmsSuccessful: "SMS successfully sent",
    };
    static stringPlaceholders = {
        jobId: "jobId",
        selected: "selected",
        smsField: "cellphone",
        consolidatedGroup: "consolidatedGroup",
        outgoing: "Outgoing",
        externalCommunication: "External Communication",
        communicationType: "CommunicationType",
        autoSendDetails: "autoSendDetails",
        commType: "communicationType",
        attachmentType: "attachmentType"
    };
    static ERROR_SENDING_SMS = "Error sending sms. Please contact your system administrator.";
    static ERROR_LOGGING_SMS = "Error logging the external communication. Please contact your system administrator.";
}
